import React from 'react';
import styled from 'styled-components';
import Menu from '../../Components/AdminComponents/Menu';

import Widget from '../../Components/AdminComponents/Widget';
import TodayWidget from '../../Components/AdminComponents/TodayWidget';
import Featured from '../../Components/AdminComponents/Featured';
import Chart from '../../Components/AdminComponents/Chart';

function UserStats({ title, isMobile }) {
  return (
    <StatsStyled>
      <Menu title={title} isMobile={isMobile} />
      <div className="dashboard-container">
        <div className="datatable">
          <div className="charts">
            <Featured />
            <Chart aspect={2 / 1} title={'Last months (Revenue)'} />
          </div>
          <div className="widgets">
            <Widget type="user" />
            <Widget type="photos" />
            <Widget type="albums" />
            <TodayWidget type="sign" />
          </div>
          <div className="bottom"></div>
        </div>
      </div>
    </StatsStyled>
  );
}
const StatsStyled = styled.div`
  display: flex;
  padding-top: 4rem;
  min-height: 100vh;
  .dashboard-container {
    flex: 6;
    .datatable {
      padding: 20px;
      .datatable-title {
        width: 100%;
        font-size: 14px;
        color: var(--accent-blue);
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .widgets,
      .charts {
        display: flex;
        padding: 20px 0;
        gap: 20px;
        @media screen and (max-width: 956px) {
          display: block;
        }
      }

      .charts {
        padding: 5px, 20px;
      }

      .bottom {
        .list-title {
          font-size: 16px;
          font-weight: 500;
          margin-bottom: 0px;
          color: var(--accent-blue);
        }
      }
    }
  }
`;
export default UserStats;
